export const formStyles = {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
};

export const submitButtonContentStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '8px',
};
